export default {
  init(store, domEl) {
    function onChange(event) {
      if (event.target.value) {
        window.location = event.target.value;
      }
    }
    domEl.addEventListener('change', onChange);
  },
};
